export const GET_TYPE_PROPERTIES = "GET_TYPE_PROPERTIES";
export const GET_TYPE_PROPERTIES_SUCCESS = "GET_TYPE_PROPERTIES_SUCCESS";
export const GET_TYPE_PROPERTIES_3_SUCCESS = "GET_TYPE_PROPERTIES_3_SUCCESS";
export const GET_TYPE_PROPERTIES_FAIL = "GET_TYPE_PROPERTIES_FAIL";

export const ADD_NEW_TYPE_PROPERTY = "ADD_NEW_TYPE_PROPERTY";
export const ADD_TYPE_PROPERTY_SUCCESS = "ADD_TYPE_PROPERTY_SUCCESS";
export const ADD_TYPE_PROPERTY_FAIL = "ADD_TYPE_PROPERTY_FAIL";

export const UPDATE_TYPE_PROPERTY = "UPDATE_TYPE_TYPE_PROPERTY";
export const UPDATE_TYPE_PROPERTY_SUCCESS = "UPDATE_TYPE_PROPERTY_SUCCESS";
export const UPDATE_TYPE_PROPERTY_FAIL = "UPDATE_TYPE_PROPERTY_FAIL";

export const DELETE_TYPE_PROPERTY = "DELETE_TYPE_PROPERTY";
export const DELETE_TYPE_PROPERTY_SUCCESS = "DELETE_TYPE_PROPERTY_SUCCESS";
export const DELETE_TYPE_PROPERTY_FAIL = "DELETE_TYPE_PROPERTY_FAIL";

export const MODAL_TYPE_PROPERTY_SHOW = "MODAL_TYPE_PROPERTY_SHOW";

export const ACTION_GET_TYPE_PROPERTIES_SELECT = "ACTION_GET_TYPE_PROPERTIES_SELECT";
export const GET_TYPE_PROPERTIES_SELECT_SUCCESS = "GET_TYPE_PROPERTIES_SELECT_SUCCESS";


export const getTypeProperties = (data) => ({
    type: GET_TYPE_PROPERTIES,
    payload: data,
  });
  
  export const getTypePropertiesSuccess = typeProperties => ({
    type: GET_TYPE_PROPERTIES_SUCCESS,
    payload: typeProperties,
  });

  export const actionGetTypePropertiesSelect = (data) => ({
    type: ACTION_GET_TYPE_PROPERTIES_SELECT,
    payload: data,
  });
  
  export const actionGetTypePropertiesSelectSuccess = typeProperties => ({
    type: GET_TYPE_PROPERTIES_SELECT_SUCCESS,
    payload: typeProperties,
  });


  export const getTypeProperties3Success = typeProperties => ({
    type: GET_TYPE_PROPERTIES_3_SUCCESS,
    payload: typeProperties,
  });
  
  export const getTypePropertiesFail = error => ({
    type: GET_TYPE_PROPERTIES_FAIL,
    payload: error,
  });
  
  export const addNewTypeProperty = typeProperty => ({
    type: ADD_NEW_TYPE_PROPERTY,
    payload: typeProperty,
  });
  
  export const addTypePropertySuccess = typeProperty => ({
    type: ADD_TYPE_PROPERTY_SUCCESS,
    payload: typeProperty,
  });
  
  export const addTypePropertyFail = error => ({
    type: ADD_TYPE_PROPERTY_FAIL,
    payload: error,
  });
  
  export const updateTypeProperty = typeProperty => ({
    type: UPDATE_TYPE_PROPERTY,
    payload: typeProperty,
  });
  
  export const updateTypePropertySuccess = typeProperty => ({
    type: UPDATE_TYPE_PROPERTY_SUCCESS,
    payload: typeProperty,
  });
  
  export const updateTypePropertyFail = error => ({
    type: UPDATE_TYPE_PROPERTY_FAIL,
    payload: error,
  });
  
  export const deleteTypeProperty = typeProperty => ({
    type: DELETE_TYPE_PROPERTY,
    payload: typeProperty,
  });
  
  export const deleteTypePropertySuccess = typeProperty => ({
    type: DELETE_TYPE_PROPERTY_SUCCESS,
    payload: typeProperty,
  });
  
export const deleteTypePropertyFail = error => ({
    type: DELETE_TYPE_PROPERTY_FAIL,
    payload: error,
  });

export const modalTypePropertyShow = flag => ({
    type: MODAL_TYPE_PROPERTY_SHOW,
    payload:flag,
})